export const getQueryValue = (query: string | string[] = ""): string =>
  Array.isArray(query) ? query[0] : query;
